// Copyright (c) 2020 Deere & Company

import alertsReducer from '../shared/reducer/alerts';
import busyCounter from '../shared/reducer/busy-counter';
import { combineReducers } from 'redux';
import reports from '../shared/reducer/reports';
import unit from '../shared/reducer/unit';

export const getApplicationReducers = () => combineReducers( {
    alerts: alertsReducer,
    busyCounter,
    reports,
    unit
} );
